import { ByProductPaymentPlanDealDiscount } from './ByProductRule';
import { GeneralManyPaymentPlanDealsDiscounts } from './GeneralRule';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const items = [
  {
    key: 'regra-geral',
    label: 'Regra geral',
    content: () => <GeneralManyPaymentPlanDealsDiscounts />
  },
  {
    key: 'regra-produto',
    label: 'Regra por produto',
    content: () => <ByProductPaymentPlanDealDiscount />
  }
];

export const PaymentPlanDealsDiscountsList = () => {
  return (
    <ListLayout title="Regras de desconto" canCreate={false}>
      <Tabs
        defaultActiveKey={items[0].key}
        size="middle"
        className="custom-tabs"
      >
        {items.map(tab => {
          return (
            <TabPane tab={tab.label} key={tab.key}>
              {tab.content()}
            </TabPane>
          );
        })}
      </Tabs>
    </ListLayout>
  );
};
